import * as evmChains from 'viem/chains';

import { Currency, EVM_NATIVE_TOKENS } from '@/constants';
import { EvmCurrency, TronCurrency } from '@/types';

// https://github.com/ChainAgnostic/CAIPs/blob/main/CAIPs/caip-122.md
// https://namespaces.chainagnostic.org/bip122/caip2
export const CAIP_122_IDS: Record<Currency.BTC | Currency.DOGE | Currency.LTC, string> = {
  [Currency.BTC]: 'bip122:000000000019d6689c085ae165831e93',
  [Currency.DOGE]: 'bip122:1a91e3dace36e2be3bf030a65679fe82',
  [Currency.LTC]: 'bip122:12a765e31ffd4059bada1e25190f6e98',
  //   [Currency.BCH]: 'bip122:000000000000000000651ef99cb9fcbe',
};

// First 16 bytes of the Solana mainnet-beta genesis hash
// (5eykt4UsFv8P8NJdTREpY1vzqKqZKvdpKuc147dw2N9d), same scheme as bip122 chain ids.
// https://namespaces.chainagnostic.org/solana/caip2
export const SOLANA_CHAIN_ID = BigInt('0x45296998a6f8e2a784db5d9f95e18fc2').toString();

export const CHAIN_ID_TO_NATIVE_CURRENCY: Record<string, Currency> = {
  // EVM
  [evmChains.mainnet.id]: Currency.ETH,
  [evmChains.bsc.id]: Currency.BNB,
  [evmChains.tron.id]: Currency.TRX,
  [evmChains.polygon.id]: Currency.POL,
  [evmChains.arbitrum.id]: Currency.ETH_ARB,
  [evmChains.base.id]: Currency.ETH_BASE,
  // Bitcoin-like
  [BigInt('0x' + CAIP_122_IDS[Currency.BTC].split(':')[1]).toString()]: Currency.BTC,
  [BigInt('0x' + CAIP_122_IDS[Currency.DOGE].split(':')[1]).toString()]: Currency.DOGE,
  [BigInt('0x' + CAIP_122_IDS[Currency.LTC].split(':')[1]).toString()]: Currency.LTC,
  // Solana
  [SOLANA_CHAIN_ID]: Currency.SOL,
};

export const NATIVE_EVM_CURRENCY_TO_CHAIN_ID: Record<EvmCurrency | TronCurrency, number> = Object.fromEntries(
  Object.entries(CHAIN_ID_TO_NATIVE_CURRENCY)
    .filter(([_, currency]) => (EVM_NATIVE_TOKENS as Currency[]).includes(currency) || currency === Currency.TRX)
    .map(([chainId, currency]) => [currency, Number(chainId)])
) as Record<EvmCurrency | TronCurrency, number>;
